export default __webpack_public_path__ + "static/media/Kapildhara-Fall.9e50f9a5.jpg";